import { render, staticRenderFns } from "./DistributionBreakdown.vue?vue&type=template&id=77616ec8&scoped=true&"
import script from "./DistributionBreakdown.vue?vue&type=script&lang=js&"
export * from "./DistributionBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./DistributionBreakdown.vue?vue&type=style&index=0&id=77616ec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77616ec8",
  null
  
)

export default component.exports